<template>
  <template v-if="!loading && quesData">
    <NoticeBar
      v-if="$store.getters.getIsPreview && $store.getters.getIsPreview === 1"
      background="#FFF6EF"
      color="#FA964E"
      text="提示：当前为预览页面，答案不被记录"
    />
    <!-- 自定义的背景 -->
    <div class="content-diy-bg"></div>
    <div
      class="content-wrap main-content"
      :class="{ top: !Boolean($route.query.isStudy) }"
    >
      <div v-if="!Boolean($route.query.isStudy)" class="top-timer">
        倒计时
        <Count-down
          @finish="handleCountDownFinished"
          class="timer"
          :time="
            $store.getters.getQuesSetting?.timePass
              ? $store.getters.getQuesSetting?.timePass * 60 * 1000
              : 60 * 60 * 1000
          "
        />
      </div>
      <div
        class="single-content"
        v-if="!partLoading"
        @click.capture="handleCaptureClick"
      >
        <!-- 个人信息填空题，单项填空 -->
        <Info-Input
          v-if="
            quesData?.questionType === 11 ||
            quesData?.questionType === 16 ||
            quesData?.questionType === 21 ||
            quesData?.questionType === 22 ||
            quesData?.questionType === 24 ||
            quesData?.questionType === 4 ||
            quesData?.questionType == 24 ||
            quesData?.questionType == 25
          "
          :data="quesData"
          :quesIndex="$route.params.id - 1"
          :currentChecked="
            currentAnswer.value && JSON.stringify(currentAnswer.value) !== '[]'
              ? currentAnswer.value
              : ''
          "
          :showFeedBack="showFeedBack"
          :showMultiSubmit="showMultiSubmit"
          @multiSubmit="handleMultiSubmit"
          @inputChange="handleInputChange"
        />
        <!-- 城市选择 -->
        <City-Select
          v-else-if="
            quesData?.questionType == 9 || quesData?.questionType == 10
          "
          :quesIndex="$route.params.id - 1"
          :data="quesData"
          :value="currentAnswer.value ? currentAnswer.value[0] : ''"
          @selectCity="handleSelectCity"
        />
        <!-- 级联题 -->
        <Cascader
          v-else-if="quesData.questionType === 20"
          :data="quesData"
          :currentChecked="
            currentAnswer.value && JSON.stringify(currentAnswer.value) !== '[]'
              ? currentAnswer.value
              : ''
          "
          :quesIndex="$route.params.id - 1"
          @cascaderChange="handleInputChange"
        />
        <Multi-Choice
          v-else-if="quesData?.questionType === 18"
          @changeChoice="handleChangeChoice"
          @radioSelect="handleRadioSelect"
          @multiSubmit="handleMultiSubmit"
          :data="quesData"
          :currentChecked="currentAnswer.value ? currentAnswer.value : []"
          :showFeedBack="showFeedBack"
          :quesIndex="$route.params.id - 1"
          :showMultiSubmit="showMultiSubmit"
        />
        <Single-Choice
          v-else
          @changeChoice="handleChangeChoice"
          @radioSelect="handleRadioSelect"
          @singleSubmit="handleMultiSubmit"
          :data="quesData"
          :currentChecked="currentAnswer.value[0]"
          :quesIndex="$route.params.id - 1"
          :showFeedBack="showFeedBack"
        />
      </div>
      <Loading class="loading-center" v-else type="spinner">加载中...</Loading>
      <div
        :class="
          Boolean($route.query.isStudy) && id < $store.getters.getAnswers.length
            ? 'btn-list-study'
            : 'btn-list'
        "
      >
        <Button
          :disabled="id <= 1 || partLoading"
          @click="handleBtnClick('pre')"
          class="btn"
          :class="{
            'special-submit-btn': $route.query.questionActiveKey === '2d4abe3fcec0479f9ced38eb05822616',
          }"
          >上一题</Button
        >
        <Button
          v-if="id < $store.getters.getAnswers.length"
          @click="handleBtnClick('next')"
          :disabled="partLoading"
          class="btn"
          :class="{
            'special-submit-btn': $route.query.questionActiveKey === '2d4abe3fcec0479f9ced38eb05822616',
          }"
          >下一题</Button
        >
        <Button
          :loading="submitLoading"
          v-else
          @click="
            () => {
              handleBtnClick('submit')
              handleBuryClick('提交')
            }
          "
          class="btn"
          :class="{
            'special-submit-btn': $route.query.questionActiveKey === '2d4abe3fcec0479f9ced38eb05822616',
          }"
          >提交</Button
        >
        <Button
          v-if="
            Boolean($route.query.isStudy) &&
            id < $store.getters.getAnswers.length
          "
          @click="
            () => {
              handleBtnClick('submit')
              handleBuryClick('完成学习')
            }
          "
          class="btn-study"
          :class="{
            'special-submit-btn': $route.query.questionActiveKey === '2d4abe3fcec0479f9ced38eb05822616',
          }"
          >完成学习</Button
        >
      </div>
      <Footer :id="Number(id)" />
    </div>
  </template>
  <Loading class="center" color="#2faeff" v-else type="spinner" vertical
    >加载中...</Loading
  >
</template>

<script>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter, onBeforeRouteUpdate } from 'vue-router'
import { useStore } from 'vuex'

import { CountDown, Button, Loading, NoticeBar, Dialog } from 'vant'
import { getQueryString } from '@/utils/tools'
import { useCommonCountDownEffect } from '@/effects/countdownEffect'
import { useCommonSubmitEffect } from '@/effects/submitEffect'
import {
  useCommonStudyListEffect,
  useCommonQuesListEffect,
} from '@/effects/quesListEffect'
import { getStudyQuesList } from '@/api/index'
import { addPointByStudy } from '@/api/rank'
import SingleChoice from '@/components/choice/SingleChoice'
import MultiChoice from '@/components/choice/MultiChoice'
import Cascader from '@/components/cascader/index'
import Footer from './components/footer'
import InfoInput from '@/components/input/InfoInput'
import CitySelect from '@/components/citySelect/index'
import router from '@/router'
import { onBeforeRouteLeave } from 'vue-router'

export default {
  components: {
    Loading,
    CountDown,
    SingleChoice,
    MultiChoice,
    Cascader,
    InfoInput,
    CitySelect,
    Button,
    Footer,
    NoticeBar,
  },
  setup() {
    const { list, quesData, loading, showFeedBack } = useListEffect()

    const {
      checked,
      currentAnswer,
      handleChangeChoice,
      handleRadioSelect,
      handleSelectCity,
      handleInputChange,
    } = useOptionClickEffect()

    // useRouterChangeEffect(list, quesData, currentAnswer, isStopClick)
    const { isStopClick, handleCaptureClick } = useClickEffect()
    // 确保useStore在setup中执行
    const { handleSubmitClick } = useCommonSubmitEffect()
    const {
      id,
      handleBtnClick,
      showMultiSubmit,
      handleMultiSubmit,
      partLoading,
      submitLoading,
    } = useJumpQuesEffect(
      list,
      quesData,
      checked,
      currentAnswer,
      isStopClick,
      handleSubmitClick
    )

    // 点击埋点
    const store = useStore()
    const handleBuryClick = (name) => {}

    // 倒计时结束
    const { handleCountDownFinished } = countdownEffect(submitLoading)

    const type = getQueryString('type')

    onBeforeRouteLeave((to, from, next) => {
      if (to.fullPath.startsWith('/?questionActiveKey') && type == 'exam') {
        setTimeout(() => {
          Dialog.confirm({
            title: '提示',
            message: '您还未提交作答！',
            confirmButtonColor: '#388fff',
            showCancelButton: true,
            closeOnClickOverlay: true,
            confirmButtonText: '提交',
            cancelButtonText: '继续作答',
          })
            .then(() => {
              next(false)
              setTimeout(() => {
                handleBtnClick('submit')
              }, 100)
            })
            .catch(() => {
              next(false)
            })
        }, 100)
      } else {
        next()
      }
    })

    return {
      loading,
      id,
      list,
      quesData,
      submitLoading,
      handleBtnClick,
      checked,
      currentAnswer,
      handleChangeChoice,
      handleCaptureClick,
      handleBuryClick,
      showFeedBack,
      showMultiSubmit,
      handleMultiSubmit,
      handleCountDownFinished,
      handleInputChange,
      handleRadioSelect,
      handleSelectCity,
      partLoading,
    }
  },
}

// 初始化数据
const useListEffect = () => {
  const store = useStore()
  const list = ref([])
  const quesData = ref(null)
  const isStudy = getQueryString('isStudy')
  // 学习模式显示解析
  const showFeedBack = ref(false)

  const { getQuesData, loading } = useCommonQuesListEffect()

  if (isStudy) {
    showFeedBack.value = true
    loading.value = true
    getStudy(list, quesData, store, loading)
  } else {
    showFeedBack.value = false
    // list.value = [...store.getters.getQuesList]
    getQuesData(list, quesData)
  }

  return {
    list,
    quesData,
    loading,
    showFeedBack,
  }
}

// 处理跳转题目
const useJumpQuesEffect = (
  list,
  quesData,
  checked,
  currentAnswer,
  isStopClick,
  handleSubmitClick
) => {
  const router = useRouter()
  const route = useRoute()
  const showMultiSubmit = ref(true)
  const handleMultiSubmit = () => {
    showMultiSubmit.value = false
    isStopClick.value = true
  }
  const id = ref(Number(route.params.id))
  quesData.value = list.value[id.value - 1]

  const store = useStore()

  // 路由切换逻辑，保存这一次的选择，拿出来下一个路由的选择
  onBeforeRouteUpdate((to, from) => {
    if (isStudy) {
      // 跳转题目的时候，重新拿一遍store中的list
      list.value = store.getters.getStudyQuesList
    }
    id.value = to.params.id
    quesData.value = list.value[id.value - 1]
    store.commit('changeAnswers', {
      index: from.params.id - 1,
      data: currentAnswer.value,
    })
    const answers = store.getters.getAnswers
    const tmpAnswer = answers[id.value - 1]
    console.log('answers', answers)
    // 单多选不太一样
    if (tmpAnswer?.questionType === 18) {
      tmpAnswer.value = tmpAnswer.answers.map((item) => item.optionKey)
    }

    // 学习模式 填空题回显问题
    // if (tmpAnswer?.questionType === 4) {

    //   if (tmpAnswer?.value) {
    //     currentAnswer.value = tmpAnswer
    //     showMultiSubmit.value = false
    //   } else {
    //     showMultiSubmit.value = true
    //   }
    // }

    if (
      tmpAnswer &&
      JSON.stringify(tmpAnswer.value) !== '[]' &&
      JSON.stringify(tmpAnswer.value) !== '[""]'
    ) {
      console.log('tmpAnswer sssss', tmpAnswer)
      isStopClick.value = true
      showMultiSubmit.value = false
      currentAnswer.value = tmpAnswer
    } else {
      isStopClick.value = false
      currentAnswer.value = {
        value: [],
      }
      showMultiSubmit.value = true
      console.log('showMultiSubmit sssss', showMultiSubmit)
    }

  })

  const isStudy = getQueryString('isStudy')

  // 提交加载
  const submitLoading = ref(false)
  const { getStudyList, partLoading } = useCommonStudyListEffect()
  const handleBtnClick = async (type) => {
    // 提交按钮
    if (type === 'submit') {
      store.commit('changeAnswers', {
        index: id.value - 1,
        data: currentAnswer.value,
      })

      // 看看store中存的答案有没有选择的题目
      const selectList = store.getters.getAnswers.filter((item) => item)
      let message = ''
      // 选择的题目数量小于整体的题目数量则存在未选择的题目
      if (selectList.length < list.value.length) {
        message = '您有尚未完成的题目，确认提交吗？'
      } else {
        message = '确认提交吗？'
      }
      // 格式化提交数据
      const answers = formatAnswer(store.getters.getAnswers)

      const res = answers.filter((item) => item.answers.length === 0)

      console.log(list.value.length, '总题目', list.value)
      console.log(answers.length, '作答的', answers)
      console.log(res.length, '作答没答案的', res)

      // 试题学习一个题都没答
      // if (answers.length == 0 || answers.length == res.length && isStudy != '') {
      //   Dialog({message: '您未进行答题'});
      //   return;
      // }

      // 模拟答题、正式考试必须全答
      if (
        (answers.length < list.value.length || res.length !== 0) &&
        isStudy == ''
      ) {
        Dialog({ message: '您有题目未完成' })
        return
      }

      // 试题学习必须全答才有积分
      if (
        (answers.length < list.value.length || res.length !== 0) &&
        isStudy != ''
      ) {
        Dialog.confirm({
          title: '提示',
          message: '您有尚未学习的题目，确认提交吗？',
          confirmButtonColor: '#388fff',
        })
          .then(async () => {
            submitLoading.value = true
            await handleSubmitClick(answers)
            submitLoading.value = false
          })
          .catch(() => {
            submitLoading.value = false
          })

        return
      }

      Dialog.confirm({
        title: '提示',
        message,
        confirmButtonColor: '#388fff',
      })
        .then(async () => {
          submitLoading.value = true
          await handleSubmitClick(answers)
          // await addScore()
          submitLoading.value = false
        })
        .catch(() => {
          submitLoading.value = false
        })

      // 学习增加积分
      const addScore = async () => {
        await handleSubmitClick(answers)
        if (route.query.isStudy) {
          const formData = new FormData()
          formData.append(
            'questionActiveKey',
            route.query.questionActiveKey + ''
          )
          formData.append('token', store.getters.getToken + '')
          await addPointByStudy(formData)
        }
      }

      return null
    }
    // 上一道题
    if (type === 'pre') {
      --id.value
      if (!list.value[id.value - 1]) {
        await getStudyList(id.value)
      }
    }
    // 下一道题
    if (type === 'next') {
      ++id.value
      // 最后一项的时候不需要再加了
      if (id.value > list.value.length) {
        return
      }
      // 假如没有值，则获取新的分页
      if (!list.value[id.value - 1]) {
        await getStudyList(id.value)
      }
    }
    router.replace({
      path: `/single/${id.value}`,
      query: route.query,
    })
  }

  return {
    id,
    quesData,
    handleBtnClick,
    showMultiSubmit,
    handleMultiSubmit,
    partLoading,
    submitLoading,
  }
}

// 获取学习列表
const getStudy = async (list, quesData, store, loading) => {
  if (store.getters.getStudyQuesList && store.getters.getStudyQuesList.length) {
    list.value = [...store.getters.getStudyQuesList]
    quesData.value = list.value[0]
    loading.value = false
    // 初始化答案数组
    store.commit('initAnswers', {
      length: list.value.length,
    })
    return
  }
  const questionActiveKey = getQueryString('questionActiveKey')
  const result = await getStudyQuesList({
    questionActiveKey,
    isPreview: 3,
    pageSize: 10,
    offSet: 1,
  })
  if (result?.ok) {
    list.value = [...result.data.rows]
    const total = result.data?.total ? result.data?.total : 0
    list.value.length = total
    quesData.value = list.value[0]
    // 初始化answers长度
    store.commit('initAnswers', {
      length: total,
    })
    store.commit('initStudyQuesList', {
      list: list.value,
    })
  }
  loading.value = false
}

// 点击选项相关逻辑
const useOptionClickEffect = () => {
  const checked = ref('')
  const currentAnswer = ref({
    value: [],
  })
  const handleChangeChoice = (item) => {
    // checked.value = item
  }

  // 选择题
  const handleRadioSelect = (data) => {
    currentAnswer.value = data
  }
  // 填空题
  const handleInputChange = (data) => {
    currentAnswer.value = data
  }
  // 省市区
  const handleSelectCity = (data) => {
    currentAnswer.value = data
  }

  return {
    checked,
    currentAnswer,
    handleChangeChoice,
    handleRadioSelect,
    handleSelectCity,
    handleInputChange,
  }
}

// 学习模式答题后不可修改设置
const useClickEffect = () => {
  const isStopClick = ref(false)
  const isStudy = getQueryString('isStudy')

  const handleCaptureClick = (e) => {
    if (isStopClick.value && isStudy) {
      e.stopPropagation()
    }
  }

  return {
    isStopClick,
    handleCaptureClick,
  }
}

// 格式化单多选答案
const formatChoice = (data) => {
  return {
    questionKey: data.questionKey,
    questionType: data.questionType,
    answers: [
      {
        questionKey: data.questionKey,
        optionKey: data.value.join(','),
        answerContent: data.answerContent,
      },
    ],
  }
}
// 格式化填空题答案
const formatBlankAnswer = (data) => {
  return {
    questionKey: data.questionKey,
    questionType: data.questionType,
    answers: [
      {
        questionKey: data.questionKey,
        optionKey: data.optionKey,
        answerContent: data.value,
      },
    ],
  }
}

// 格式化答案
const formatAnswer = (answers) => {
  const tmp = []
  answers.forEach((data) => {
    if (
      JSON.stringify(data.value) === '[]' ||
      JSON.stringify(data.value) === '[""]'
    ) {
      return
    }
    let obj = {}
    // 填空答案
    if (data.type === 'input') {
      obj = formatBlankAnswer(data)
    } else if (
      data.questionType === 9 ||
      data.questionType === 10 ||
      data.questionType === 18
    ) {
      // 城市选择
      obj = data
    } else {
      obj = formatChoice(data)
    }
    tmp.push(obj)
  })

  return tmp
}

// 倒计时结束相关逻辑
const countdownEffect = (submitLoading) => {
  const store = useStore()
  const isStudy = Boolean(getQueryString('isStudy'))
  const { handleCountDown } = useCommonCountDownEffect()
  const handleCountDownFinished = async () => {
    // 说明正在提交，防止重复
    if (submitLoading.value) {
      console.log('submitLoading', submitLoading)
      return
    }
    if (isStudy) {
      return null
    }
    const answers = formatAnswer(store.getters.getAnswers, [
      ...store.getters.getQuesList,
    ])
    submitLoading.value = true
    await handleCountDown(answers)
    submitLoading.value = false
  }

  return {
    handleCountDownFinished,
  }
}
</script>

<style lang="scss" scoped>
.top-timer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background-color: #fff6ef;
  font-size: 28px;
  font-weight: 500;
  color: #fa964e;
  z-index: 100;

  .timer {
    display: inline-block;
    font-size: 28px;
    font-weight: 500;
    color: #fa964e;
  }
}
.learn-done {
  text-align: right;
  padding: 10px 30px 0 0;

  button {
    width: 280px;
    height: 88px;
    font-size: 34px;
    font-weight: 500;
    color: #ffffff;
    background: linear-gradient(-90deg, #388fff 0%, #2faeff 100%);
    border-radius: 44px;
  }
  //::v-deep .van-button__text{
  //  font-size: 20px;
  //}
}
.content-wrap {
  // padding-bottom: 228px;
  margin: 0 auto;
  min-height: 100vh;
}
.single-content {
  // overflow-y: scroll;
  // height: 1240px;
  padding-top: 40px;
  padding-bottom: 240px;
}
.top {
  box-sizing: border-box;
  padding-top: 70px;
}
.btn-list {
  position: fixed;
  justify-content: center;
  display: flex;
  left: 0;
  right: 0;
  bottom: 97px;
  border-top: 1px solid #e0e0e0;
  padding-top: 30px;
  //padding-bottom: 120px;
  background-color: #ffffff;

  .btn {
    width: 280px;
    height: 88px;
    font-size: 34px;
    font-weight: 500;
    color: #ffffff;
    background: linear-gradient(-90deg, #388fff 0%, #2faeff 100%);
    border-radius: 44px;

    &:last-child {
      margin-left: 69px;
    }
  }
}

.btn-list-study {
  position: fixed;
  justify-content: center;
  display: flex;
  left: 0;
  right: 0;
  bottom: 97px;
  border-top: 1px solid #e0e0e0;
  padding-top: 30px;
  //background-color: #ffffff;

  .btn {
    width: 200px;
    height: 88px;
    font-size: 27px;
    font-weight: 500;
    color: #ffffff;
    background: linear-gradient(-90deg, #388fff 0%, #2faeff 100%);
    border-radius: 44px;
    margin-left: 20px;

    &:first-child {
      margin-left: 0;
    }
  }

  .btn-study {
    width: 200px;
    height: 88px;
    font-size: 27px;
    font-weight: 500;
    color: #ffffff;
    background: linear-gradient(-90deg, #01d6b0 0%, #00eabb 100%);
    border-radius: 44px;
    margin-left: 20px;
  }

  .special-submit-btn {
    background: linear-gradient(
      -90deg
      , rgba(240,111,23,1) 0%, rgba(244,71,34,1) 100%) !important;
  border: none;
  }
}

.loading-center {
  display: block;
  margin: 0 auto;
  margin-top: 400px;
  text-align: center;
}

// @media (min-width: 1100px) {
//   .btn-list {
//     position: relative;
//     bottom: auto;
//     margin-top: 50px;
//     margin: 0 auto;
//     text-align: center;
//   }
// }
</style>
